export const vlist = [
  {
    "id": 1,
    "url": "https://storagecdn.xuetangx.com/unesco/ICEE_promo.mp4",
    "title": "ICEE Promo",
    "poster": "//storage.xuetangx.com/unesco/img/0db252e25a64d7d86f82801a27072b1c.jpg"
  },
  {
    "id": 2,
    "url": "https://unesco.oss-cn-beijing.aliyuncs.com/file/Tsinghua%20Engineering%20Education%20Video%20for%20ASEE%202023-720P-1113.mp4",
    "title": "WU Qidi（吴启迪）",
    "poster": "https://unesco.oss-cn-beijing.aliyuncs.com/images/ASEE.png"
  },
  {
    "id": 3,
    "url": "https://unesco.oss-cn-beijing.aliyuncs.com/video/video3-GU%20Binglin%EF%BC%88%E9%A1%BE%E7%A7%89%E6%9E%97%EF%BC%89.mp4",
    "title": "GU Binglin（顾秉林）",
    "poster": null
  },
  {
    "id": 4,
    "url": "https://unesco.oss-cn-beijing.aliyuncs.com/video/video4-YANG%20Bin%EF%BC%88%E6%9D%A8%E6%96%8C%EF%BC%89.mp4",
    "title": "YANG Bin（杨斌）",
    "poster": null
  },
  {
    "id": 5,
    "url": "https://unesco.oss-cn-beijing.aliyuncs.com/video/video5-YUAN%20Si%EF%BC%88%E8%A2%81%E9%A9%B7%EF%BC%89.mp4",
    "title": "YUAN Si（袁驷）",
    "poster": null
  },
  {
    "id": 6,
    "url": "https://unesco.oss-cn-beijing.aliyuncs.com/video/video6-WANG%20Yuming%EF%BC%88%E7%8E%8B%E7%8E%89%E6%98%8E%EF%BC%89.mp4",
    "title": "WANG Yuming（王玉明）",
    "poster": null
  },
  {
    "id": 7,
    "url": "https://unesco.oss-cn-beijing.aliyuncs.com/video/video7-LUO%20Yi%EF%BC%88%E7%BD%97%E6%AF%85%EF%BC%89.mp4",
    "title": "LUO Yi（罗毅）",
    "poster": null
  },
  {
    "id": 8,
    "url": "https://unesco.oss-cn-beijing.aliyuncs.com/video/video8-ZHUANG%20Weimin%EF%BC%88%E5%BA%84%E6%83%9F%E6%95%8F%EF%BC%89.mp4",
    "title": "ZHUANG Weimin（庄惟敏）",
    "poster": null
  },
  {
    "id": 9,
    "url": "https://unesco.oss-cn-beijing.aliyuncs.com/video/video9-LI%20Manli%EF%BC%88%E6%9D%8E%E6%9B%BC%E4%B8%BD%EF%BC%89.mp4",
    "title": "LI Manli（李曼丽）",
    "poster": null
  },
  {
    "id": 10,
    "url": "https://unesco.oss-cn-beijing.aliyuncs.com/video/video10-HONG%20Bo%EF%BC%88%E6%B4%AA%E6%B3%A2%EF%BC%89.mp4",
    "title": "HONG Bo（洪波）",
    "poster": null
  },
  {
    "id": 11,
    "url": "https://unesco.oss-cn-beijing.aliyuncs.com/video/video11-WANG%20Shuaiguo%EF%BC%88%E7%8E%8B%E5%B8%85%E5%9B%BD%EF%BC%89.mp4",
    "title": "WANG Shuaiguo（王帅国）",
    "poster": null
  },
  {
    "id": 12,
    "url": "https://unesco.oss-cn-beijing.aliyuncs.com/video/video12-XIAO%20Wei%EF%BC%88%E8%82%96%E8%96%87%EF%BC%89.mp4",
    "title": "XIAO Wei（肖薇）",
    "poster": null
  },
  {
    "id": 13,
    "url": "https://unesco.oss-cn-beijing.aliyuncs.com/video/video13-ASEE%202024.mp4",
    "title": "ASEE 2024",
    "poster": null
  }
]
